/* Backtest Page — Equity curves, trade log, risk metrics
   Uses Phase 4.1 components */

import { renderEquityCurve } from '../components/EquityCurve';
import { renderMonthlyHeatmap } from '../components/MonthlyHeatmap';
import { renderTradeLog } from '../components/TradeLog';
import { renderRiskMetricsCards } from '../components/RiskMetricsCards';
import { renderRegimeBreakdown } from '../components/RegimeBreakdown';
import { renderPhase2BacktestEngine } from '../components/charts/Phase2BacktestEngine';
import { isFeatureEnabled } from '../services/runtime-config';

export function renderBacktest(): string {
  if (isFeatureEnabled('charts_v2_engine')) {
    return '<div id="bt-v2-root"></div>';
  }

  return `
    <div class="grid-2col" style="margin-bottom: var(--space-6);">
      <div id="bt-equity"></div>
      <div id="bt-risk"></div>
    </div>
    <div class="grid-2col" style="margin-bottom: var(--space-6);">
      <div id="bt-monthly"></div>
      <div id="bt-regime"></div>
    </div>
    <div id="bt-trades"></div>
  `;
}

export function initBacktest(): void {
  if (isFeatureEnabled('charts_v2_engine')) {
    const root = document.getElementById('bt-v2-root');
    if (root) renderPhase2BacktestEngine(root);
    return;
  }

  const el = (id: string) => document.getElementById(id);

  const eqEl = el('bt-equity');
  if (eqEl) renderEquityCurve(eqEl);

  const riskEl = el('bt-risk');
  if (riskEl) renderRiskMetricsCards(riskEl);

  const monthEl = el('bt-monthly');
  if (monthEl) renderMonthlyHeatmap(monthEl);

  const regimeEl = el('bt-regime');
  if (regimeEl) renderRegimeBreakdown(regimeEl);

  const tradeEl = el('bt-trades');
  if (tradeEl) renderTradeLog(tradeEl);
}
